export * from 'depreciations/constants/depreciations_constants';



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/constants/index.js